import API from './apiConfig';

const INVOICE_API = '/invoices';

const createInvoice = async (invoice) => {
  const res = API.post(INVOICE_API + '/create/invoiceEvent', invoice, {
    withCredentials: true,
  });
  return res;
};

const getInvoices = async (payload) => {
  const res = await API.get(INVOICE_API + '/filteredInvoices', {
    withCredentials: true,
    params: payload,
  });
  return res.data;
};

const getInvoiceCSV = async (filter) => {
  const response = await API.get(INVOICE_API + '/exportCsv', {
    headers: {
      'Content-Type': 'application/json',
    },
    params: filter,
    responseType: 'blob',
    withCredentials: true,
    timeout: 1000 * 60 * 15,
  });
  return response.data;
};

const updateInvoiceStatus = async (invoiceId, filterRequest, payload) => {
  const res = await API.post('/invoices/updateStatus', {
    invoiceIds: invoiceId,
    filterRequest,
    ...payload,
  });
  return res.data;
};

const getTransactionByInvoiceId = async (invoiceId) => {
  const res = await API.get('/invoices/transactions/byInvoiceId', {
    params: {
      invoiceId,
    },
  });
  return res.data;
};

const getSearch = async (payload) => {
  const res = await API.get(INVOICE_API + '/search', {
    withCredentials: true,
    params: payload,
  });
  return res.data;
};

export {
  getInvoices,
  createInvoice,
  updateInvoiceStatus,
  getInvoiceCSV,
  getTransactionByInvoiceId,
  getSearch,
};
